export default __webpack_public_path__ + "img/39d083a6c5d1eccb1dfb906bf637cafd.svg";